var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardWasteAnalyzed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 7.2L10.425 3.525L8.95 1.075C8.75 0.741667 8.4625 0.575 8.0875 0.575C7.7125 0.575 7.425 0.741667 7.225 1.075L4.775 5.15L8.2 7.2ZM17.875 14L15.65 10.3L19.125 8.3L20.725 10.975C20.9083 11.2583 21.0083 11.575 21.025 11.925C21.0417 12.275 20.9667 12.6 20.8 12.9C20.6333 13.2333 20.3875 13.5 20.0625 13.7C19.7375 13.9 19.3833 14 19 14H17.875ZM15 21L11 17L15 13V15H19.75L18.3 17.9C18.1167 18.2333 17.8667 18.5 17.55 18.7C17.2333 18.9 16.8833 19 16.5 19H15V21ZM5.325 19C4.99167 19 4.6875 18.9125 4.4125 18.7375C4.1375 18.5625 3.93333 18.3333 3.8 18.05C3.66667 17.7833 3.60417 17.5042 3.6125 17.2125C3.62083 16.9208 3.7 16.65 3.85 16.4L4.7 15H9V19H5.325ZM2.85 16.15L1.225 12.9C1.075 12.6 1.00417 12.2792 1.0125 11.9375C1.02083 11.5958 1.11667 11.275 1.3 10.975L1.7 10.3L0 9.275L5.475 7.9L6.85 13.4L5.125 12.35L2.85 16.15ZM16.35 7.6L10.875 6.225L12.6 5.2L9.475 0H13C13.35 0 13.6792 0.0875 13.9875 0.2625C14.2958 0.4375 14.5417 0.675 14.725 0.975L16.025 3.15L17.725 2.1L16.35 7.6Z",
    fill: "#008685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWasteAnalyzed);
export default __webpack_public_path__ + "static/media/dashboard-waste-analyzed.5f5a401c4f0d09e3e2c362718dae575e.svg";
export { ForwardRef as ReactComponent };